
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { PosicaoDoCliente } from '@app/models/posicao-do-cliente.model';

@Injectable()
export class PosicaoDoClienteService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  gravar(posicaoDoCliente: PosicaoDoCliente): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'configuracoes/posicaoDoCliente', posicaoDoCliente).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `configuracoes/posicaoDoCliente/${id}`);
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `configuracoes/posicaoDoCliente/${id}`);
  }

  obterLista(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http
      .get<any>(this.URL_API + `configuracoes/posicaoDoCliente/lista/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }

  // obterTodos(): Observable<any> {
  //   return this
  //     .http<any>.get(this.URL_API + "posicaoDoCliente/")
  // }

}
